import { render } from "./CustomerUploadImage.vue?vue&type=template&id=271214fb"
import script from "./CustomerUploadImage.vue?vue&type=script&lang=js"
export * from "./CustomerUploadImage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__